import rbwStop from './meet_rbw_stop.js'

export default () => {
  return rbwStop()
}
